import Vue from "vue";
import getBaseUrl from "../config/baseUrl";

Vue.prototype.$about = new Vue({
  methods: {
    getData(language = "en") {
      let lang = language;

      if (lang === "pt") {
        lang = "pt-br";
      }

      return new Promise((resolve, reject) => {
        this.$http
          .get(`${getBaseUrl()}about/${lang}`)
          .then((result) => resolve(result.data))
          .catch((error) => reject(error));
      });
    },
  },
});
